"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CustomDateRangeStyled = require("./CustomDateRange-styled.js");
var _actions = _interopRequireDefault(require("../../store/actions"));
var _stateTypes = _interopRequireDefault(require("../../store/stateTypes"));
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CustomDateRange = function CustomDateRange(_ref) {
  var id = _ref.item.id,
    onChangeFilter = _ref.onChangeFilter,
    filters = _ref.filters;
  var onStartDateChange = function onStartDateChange(e) {
    var date = (0, _moment.default)(e.detail);
    _actions.default.onClickItem({
      id: id,
      itemState: _stateTypes.default.FILTER_ITEM_ACTIVE,
      filters: filters,
      onChangeFilter: onChangeFilter,
      startDate: date.valueOf()
    });
  };
  var onEndDateChange = function onEndDateChange(e) {
    var date = (0, _moment.default)(e.detail);
    _actions.default.onClickItem({
      id: id,
      itemState: _stateTypes.default.FILTER_ITEM_ACTIVE,
      filters: filters,
      onChangeFilter: onChangeFilter,
      endDate: date.valueOf()
    });
  };
  return /*#__PURE__*/_react.default.createElement(_CustomDateRangeStyled.StyledCustomDateRange, null, /*#__PURE__*/_react.default.createElement(_CustomDateRangeStyled.StyledDatePickerWrapper, null, /*#__PURE__*/_react.default.createElement(_CustomDateRangeStyled.StyledH6, null, "Start Date"), /*#__PURE__*/_react.default.createElement(_CustomDateRangeStyled.StyledCalciteInputDatePicker, {
    id: "basicDatePicker-startDate",
    overlayPositioning: "fixed",
    onCalciteDatePickerChange: function onCalciteDatePickerChange(e) {
      return onStartDateChange(e);
    },
    activeRange: "start"
  })), /*#__PURE__*/_react.default.createElement(_CustomDateRangeStyled.StyledDatePickerWrapper, null, /*#__PURE__*/_react.default.createElement(_CustomDateRangeStyled.StyledH6, null, "End Date"), /*#__PURE__*/_react.default.createElement(_CustomDateRangeStyled.StyledCalciteInputDatePicker, {
    id: "basicDatePicker-endDate",
    overlayPositioning: "fixed",
    onCalciteDatePickerChange: function onCalciteDatePickerChange(e) {
      return onEndDateChange(e);
    },
    activeRange: "end"
  })));
};
var _default = CustomDateRange;
exports.default = _default;